import { render } from "./ManualViewer.vue?vue&type=template&id=b1201472&scoped=true"
import script from "./ManualViewer.vue?vue&type=script&lang=js"
export * from "./ManualViewer.vue?vue&type=script&lang=js"

import "./ManualViewer.vue?vue&type=style&index=0&id=b1201472&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b1201472"]])

export default __exports__